/* tslint:disable */
/* eslint-disable */
/**
 * Atlas API
 * Atlas API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    EvidenceShare,
    EvidenceShareFromJSON,
    EvidenceShareFromJSONTyped,
    EvidenceShareToJSON,
    ResponseBase,
    ResponseBaseFromJSON,
    ResponseBaseFromJSONTyped,
    ResponseBaseToJSON,
} from './';

/**
 * 
 * @export
 * @interface EvidenceShareResponse
 */
export interface EvidenceShareResponse {
    /**
     * Message related to response
     * @type {string}
     * @memberof EvidenceShareResponse
     */
    msg: string;
    /**
     * 
     * @type {EvidenceShare}
     * @memberof EvidenceShareResponse
     */
    entry: EvidenceShare;
}

export function EvidenceShareResponseFromJSON(json: any): EvidenceShareResponse {
    return EvidenceShareResponseFromJSONTyped(json, false);
}

export function EvidenceShareResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): EvidenceShareResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'msg': json['msg'],
        'entry': EvidenceShareFromJSON(json['entry']),
    };
}

export function EvidenceShareResponseToJSON(value?: EvidenceShareResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'msg': value.msg,
        'entry': EvidenceShareToJSON(value.entry),
    };
}


